module.exports = __webpack_public_path__ + "img/no.2858fc4c.png";